// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2vaOQ","row":"Node_row__1BMyv","label":"Node_label__1PFqh","footer":"Node_footer__2z-_v"};